import { Box, Card, Container, Stack, Typography, useTheme } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { MotionViewport } from 'src/components/animate';
import Carousel, { CarouselArrows, useCarousel } from 'src/components/carousel';
import { useSettingsContext } from 'src/components/settings';
import { useResponsive } from 'src/hooks/use-responsive';
import { useLocales } from 'src/locales';

const CONFIG = [
  { label: 'penpad', imgUrl: './assets/images/home/partner/PARTNER_PENPAD.png' },

  { label: 'Blockchain Today', imgUrl: './assets/images/home/partner/PARTNER_BLOCKCHAINTODAY.png' },
  { label: 'BongA', imgUrl: './assets/images/home/partner/PARTNER_BONGA.png' },
  { label: 'FN Today', imgUrl: './assets/images/home/partner/PARTNER_FNTODAY.png' },
  { label: 'KCS', imgUrl: './assets/images/home/partner/PARTNER_KCS.png' },
  { label: 'Marvels', imgUrl: './assets/images/home/partner/PARTNER_MARVELS.png' },
  { label: '001', imgUrl: './assets/images/home/partner/PARTNER_001.png' },
  { label: 'SR Labs', imgUrl: './assets/images/home/partner/PARTNER_SRLABS.png' },

  { label: 'MAGIC SQUARE', imgUrl: './assets/images/home/partner/PARTNER_MAGICSQUARE.png' },
  { label: 'PUFF', imgUrl: './assets/images/home/partner/PARTNER_PUFF.png' },
  { label: 'COLLABLY NETWORK', imgUrl: './assets/images/home/partner/PARTNER_COLLABLYNETWORK.png' },
  { label: 'TWIPLAY', imgUrl: './assets/images/home/partner/PARTNER_TWIPLAY.png' },
  { label: 'MISES BROWSER', imgUrl: './assets/images/home/partner/PARTNER_MISESBROWSER.png' },
  { label: 'METAX', imgUrl: './assets/images/home/partner/PARTNER_METAX.png' },
  { label: 'SILVER PEGASUS', imgUrl: './assets/images/home/partner/PARTNER_SILVERPEGASUS.png' },

  { label: 'STEPMINT', imgUrl: './assets/images/home/partner/PARTNER_STEPMINT.png' },
  { label: '002', imgUrl: './assets/images/home/partner/PARTNER_002.png' },
];

function HomePartner() {
  const { t } = useLocales();
  const theme = useTheme();

  const mdUp = useResponsive('up', 'md');

  const settings = useSettingsContext();
  const isDarkMode = settings.themeMode === 'dark';

  const carousel = useCarousel({
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: '0px',
    slidesToShow: 5,
    // auto play
    autoplay: true,
    speed: 500,
    autoplaySpeed: 2000,
    // responsive
    responsive: [
      {
        // Down 900
        breakpoint: theme.breakpoints.values.md,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        // Down 650
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        // Down 400
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  const renderCarousel = (
    <Box sx={{ position: 'relative' }}>
      <CarouselArrows
        filled
        onPrev={carousel.onPrev}
        onNext={carousel.onNext}
        leftButtonProps={{
          sx: {
            p: 0.5,
            mt: -1.5,
            left: -8,
            '& svg': { width: 16, height: 16 },
          },
        }}
        rightButtonProps={{
          sx: {
            p: 0.5,
            mt: -1.5,
            right: -8,
            '& svg': { width: 16, height: 16 },
          },
        }}
      >
        <Box
          component={Carousel}
          ref={carousel.carouselRef}
          {...carousel.carouselSettings}
          sx={{
            width: 1,
            mx: 'auto',
          }}
        >
          {CONFIG.map((item, index) => (
            <Box key={index} sx={{ py: 5 }}>
              <Stack
                component={Card}
                sx={{
                  background: isDarkMode ? theme.palette.background.paper : theme.palette.grey[500],
                  p: 2,
                  width: '90%',
                  height: '120px',
                  margin: '0 auto',
                }}
                alignItems="center"
                justifyContent="center"
              >
                <img src={item.imgUrl} alt={item.label} width="100%" />
              </Stack>
            </Box>
          ))}
        </Box>
      </CarouselArrows>
    </Box>
  );

  return (
    <Container component={MotionViewport}>
      <Stack
        sx={{
          mb: { xs: 5, md: 10 },
        }}
      >
        <Typography variant="h2" textAlign="center" mb={4} color="primary">
          {t('walkup_lang_064')}
        </Typography>

        {!mdUp && renderCarousel}

        {mdUp && (
          <Stack>
            <Grid2 container justifyContent="center" columns={{ md: 14 }}>
              {CONFIG.map((item, index) => (
                <Grid2 key={index} xs={2}>
                  <Box sx={{ py: 5 }}>
                    <Stack
                      component={Card}
                      sx={{
                        background: isDarkMode
                          ? theme.palette.background.paper
                          : theme.palette.grey[800],
                        p: 2,
                        width: '90%',
                        height: '120px',
                        margin: '0 auto',
                      }}
                      alignItems="center"
                      justifyContent="center"
                    >
                      <img src={item.imgUrl} alt={item.label} width="100%" />
                    </Stack>
                  </Box>
                </Grid2>
              ))}
            </Grid2>
          </Stack>
        )}
      </Stack>
    </Container>
  );
}

export default HomePartner;
